/**
 * Cross-app link helper for reaching the POS PWA from the admin app.
 *
 * The POS app is a separate origin from the admin dashboard (different
 * Vite dev port locally, typically a different host/subdomain in
 * production). Linking to a bare `/pos/billing` resolves against the
 * *admin* origin, which has no such route — the admin catch-all then
 * traps the user on "Page coming soon...", visually indistinguishable
 * from the page hanging on load (GitHub issue #56).
 *
 * The resolution itself lives in `app-url.ts`, shared with the other
 * cross-app links; these wrappers keep the POS-specific call sites
 * (`QuickActionsBar`, `TenantDashboardContent`, `QuotationListPage`)
 * reading naturally.
 */
import { appUrl, getAppBaseUrl } from './app-url';

export function getPosBaseUrl(): string | null {
  return getAppBaseUrl('pos');
}

/**
 * Build an absolute URL into the POS app for a given path
 * (e.g. `/pos/billing?mode=quote`). Falls back to the relative path
 * when no POS origin can be resolved.
 */
export function posUrl(path: string): string {
  return appUrl('pos', path);
}
